import SectionEditImageContainer from "./SectionEditImageContainer";

export default SectionEditImageContainer;
